const basicMixin = {
    data() {
        return {
            isYX: window.data.set.currentClass === 'yx' || window.data.set.current === '10074',
            isWeCom: window.data.data.groupSendType === 'weCom',
        };
    },
    methods: {
    },
};

export default basicMixin;
